/**
 * BoasVindasWidget - sauda o usuario logado.
 *
 * Widget universal (sem permissao). Aparece no default essencial de
 * qualquer cargo. Nao faz fetch — usa `usuario` ja disponivel no
 * AuthContext.
 */
import React from "react";

import { CardBody, KpiValor, KpiSub } from "../styles";


export const meta = {
  id: "boas_vindas",
  label: "Boas-vindas",
  descricao: "Saudacao personalizada para o usuário logado.",
  categoria: "Sistema",
  permissoes: [],
  tamanho_default: "M",
  // Se essencial=true, monta no default para qualquer usuario novo.
  essencial: true,
};

// Sem fetch — dados vem do contexto.
export const fetchData = null;

function saudacao() {
  const h = new Date().getHours();
  if (h < 12) return "Bom dia";
  if (h < 18) return "Boa tarde";
  return "Boa noite";
}

export function Widget({ contexto }) {
  const usuario = contexto?.usuario;
  const nome = (usuario?.nome || usuario?.email || "vendedor").split(" ")[0];
  const cargoNome = usuario?.cargo?.nome || usuario?.cargo_nome || "";
  return (
    <CardBody>
      <KpiValor>{saudacao()}, {nome}!</KpiValor>
      <KpiSub>
        {cargoNome
          ? `Você está logado como ${cargoNome}.`
          : "Bem-vindo de volta ao PharuERP."}
      </KpiSub>
      <KpiSub>
        Personalize seu painel clicando em "Personalizar" no topo desta tela.
      </KpiSub>
    </CardBody>
  );
}
